/**
 * Утилиты для работы с темой виджета
 */

/**
 * Применяет тему виджета через CSS переменные
 * @param {Object} theme - Объект с параметрами темы
 */
export const applyWidgetTheme = (theme) => {
  const root = document.documentElement;
  
  if (theme.primaryColor) {
    root.style.setProperty('--widget-primary-color', theme.primaryColor);
  }
  if (theme.backgroundColor) {
    root.style.setProperty('--widget-background-color', theme.backgroundColor);
  }
  if (theme.textColor) {
    root.style.setProperty('--widget-text-color', theme.textColor);
  }
  if (theme.buttonTextColor) {
    root.style.setProperty('--widget-button-text-color', theme.buttonTextColor);
  }
  if (theme.borderRadius) {
    root.style.setProperty('--widget-border-radius', theme.borderRadius);
  }
};

/**
 * Получает тему по умолчанию
 * @returns {Object} Объект с параметрами темы по умолчанию
 */
export const getDefaultTheme = () => ({
  primaryColor: '#6366f1',
  backgroundColor: '#ffffff',
  textColor: '#111827',
  buttonTextColor: '#ffffff',
  borderRadius: '0.5rem',
});

/**
 * Объединяет тему с темой по умолчанию
 * @param {Object} customTheme - Кастомная тема
 * @returns {Object} Объединенная тема
 */
export const mergeTheme = (customTheme = {}) => {
  return {
    ...getDefaultTheme(),
    ...customTheme,
  };
};

